// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponse {
    static getAttributeTypeMap() {
        return TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponse.attributeTypeMap;
    }
}
TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponse.discriminator = undefined;
TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponse.additionalProperties = false;
TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponseData"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=tenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponse.js.map